export default __webpack_public_path__ + "static/media/contact.39195f13.svg";